import React, { forwardRef } from 'react';

const Card = forwardRef(function Card({
  children,
  title,
  headerActions,
  padding = 'p-6',
  className = '',
  ...props
}, ref) {
  return (
    <div
      ref={ref}
      className={`bg-white rounded-xl border border-slate-200 shadow-sm ${padding} ${className}`}
      {...props}
    >
      {(title || headerActions) && (
        <div className="flex items-center justify-between mb-4">
          {title && (
            <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
          )}
          {headerActions && (
            <div className="flex items-center gap-2">{headerActions}</div>
          )}
        </div>
      )}
      {children}
    </div>
  );
});

export default Card;
